import Vue from "vue";
import Vuex from "vuex";
import api from "@/services/api";
// import { server } from "@/services/constant";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogged: false,
    themeColor: "",
    snackbar: {},
    dialog: {},
    dialogLoader: false,
  },
  mutations: {
    SET_LOGGED_IN(state) {
      state.isLogged = true;
    },
    SET_LOGGED_OUT(state) {
      state.isLogged = false;
    },
    SET_SNACKBAR(state, snackbar) {
      state.snackbar = snackbar;
    },
    SET_DIALOG(state, dialog) {
      state.dialog = dialog;
    },
    SET_DIALOGLOADER(state, dialogLoader) {
      state.dialogLoader = dialogLoader;
    },
    SET_THEMECOLOR(state, themeColor) {
      state.themeColor = themeColor;
    },
  },
  getters: {
    isLogged(state) {
      return state.isLogged;
    },
    username(state) {
      return state.username;
    },
    fullname(state) {
      return state.fullname;
    },
    themeColor(state) {
      return state.themeColor;
    },
  },
  actions: {
    async doLogin({ commit, dispatch }, { identity, pwd, turnstile }) {
      let result = await api.login({ identity, pwd, turnstile });
      if (result == true) {
        commit("SET_LOGGED_IN");
      } else {
        dispatch("doLogout", {});
      }
    },
    setSnackbar({ commit }, snackbar) {
      (snackbar.showing = true), (snackbar.color = snackbar.color || "success"), (snackbar.timeout = snackbar.tiomeout || 3000);
      if (snackbar.color == "success") {
        snackbar.icon = "mdi-check-circle-outline";
      } else if (snackbar.color == "error") {
        snackbar.icon = "mdi-close-octagon-outline";
      } else if (snackbar.color == "warning") {
        snackbar.icon = "mdi-shield-lock-outline";
      } else if (snackbar.color == "info") {
        snackbar.icon = "mdi-bell-alert-outline";
      }
      commit("SET_SNACKBAR", snackbar);
    },
    setDialog({ commit }, dialog) {
      (dialog.showing = true),
        (dialog.titlecolor = dialog.titlecolor || "success"),
        (dialog.timeout = setTimeout(() => {
          dialog.showing = false;
        }, 1500));
      if (dialog.titlecolor == "success") {
        dialog.icon = "mdi-check-circle-outline";
      } else if (dialog.titlecolor == "error") {
        dialog.icon = "mdi-close-octagon-outline";
      } else if (dialog.titlecolor == "warning") {
        dialog.icon = "mdi-shield-lock-outline";
      } else if (dialog.titlecolor == "info") {
        dialog.icon = "mdi-bell-alert-outline";
      }
      commit("SET_DIALOG", dialog);
    },
    setDialogLoader({ commit }, dialogLoader) {
      dialogLoader.showing = dialogLoader.status;
      commit("SET_DIALOGLOADER", dialogLoader);
    },
    async restoreLogin({ commit }) {
      if (api.isLoggedIn() === true) {
        if ((await api.isCheckToken()) === true) {
          commit("SET_LOGGED_IN");
        } else {
          api.logoff();
        }
      }
    },
    doLogout({ commit }) {
      api.logoff();
      commit("SET_LOGGED_OUT");
    },
    doError({ commit }) {
      api.error();
      commit("SET_LOGGED_OUT");
    },
  },
  modules: {},
});
